import { render, staticRenderFns } from "./job-search.vue?vue&type=template&id=4800c294&"
import script from "./job-search.vue?vue&type=script&lang=js&"
export * from "./job-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports